import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { CertificatesForm } from "../form/certificates";
import { Pencil1Icon } from "@radix-ui/react-icons";

export const Certificates = (props: any) => {

	const [isOpen, setIsOpen] = useState(false);
	const [selected, setSelected] = useState({});

	const handleEdit = (certification: any, index: any) => {
		setSelected({ index, certification });
		setIsOpen(true);
	};

	return (
		<>
			<div className="col">
				{props?.certification?.map((certification: any, index: number) => {
					return (
						<>
							<div className="row bg-white">
								<div className="col-md-11 mt-1">
									<h5>{certification?.name}</h5>
									<div className="mt-1 mb-1 spec-1">
										<span></span>
										{certification?.institution},{" "}
										<span className="dot"></span>
										<span></span>
										<span className="dot"></span>
										<span>
											<br />
										</span>
									</div>
									<div className="mt-1 mb-1 spec-1">
										<span>
											<b>From:</b> {certification?.dateIssued}{" "}
											<b>To:</b>{" "}
										</span>
										<span className="dot"></span>
										{certification?.endDate !== "" ? (
											<span>{certification?.endDate}</span>
										) : (
											<span>No Expiration Date</span>
										)}
										<span className="dot"></span>
										<span>
											<br />
										</span>
									</div>
									<div className="mt-1 mb-1 spec-1">
										<span>Credential ID: </span>
										<span className="dot"></span>
										{certification?.credentialID}
										<span className="dot"></span>
										<span>
											<br />
										</span>
									</div>
									{certification?.credentialUrl !== "" ? (
											<div className="mt-1 mb-1 spec-1">
												<br/>
												<a className="btn rounded-full" target="_blank" rel="noopener noreferrer" href={certification?.credentialUrl}>SHOW CREDENTIALS</a>
												<span>
													<br />
												</span>
											</div>
										) : ("")}

								</div>
								{props.isEditCertification && (
									<div className="flex flex-row justify-end">
										<Pencil1Icon
											height={undefined}
											width={undefined}
											className="h-6 sm:h-7 cursor-pointer "
											onClick={() => handleEdit(certification, index)
											} />
									</div>
								)}
							</div>
							<hr />
						</>
					);
				})}
			</div>

			<Dialog open={isOpen} onOpenChange={setIsOpen}>
				<DialogContent>

					<CertificatesForm
						id={props.id}
						onUpdate={props.onUpdate}
						certificationDetails={selected}
					/>
				</DialogContent>

			</Dialog>

		</>
	);
};
